import type { CSSProperties, FunctionComponent } from 'react';

import { Icon } from '../../../shared/components/icon/icon';
import { SliderList } from '../../../shared/components/slider/slider';
import { Thumbnail } from '../../../shared/components/thumbnail/thumbnail';
import { createStyleHelper } from '../../../shared/utils/class-names';
import type { IGetGameSearchQuery } from '../../queries/search.graphql';

import styles from './ingame-search.module.scss';

const style = createStyleHelper(styles, 'ingame-search');

export interface IInGameSearchProps {
    onQueryChange: (query: string) => void;
    query: string;
    games: Exclude<IGetGameSearchQuery['getGameSearch'], undefined | null>;
    columnCount?: number;
    onSelectGame?: (slug: string) => void;
}

export const InGameSearch: FunctionComponent<IInGameSearchProps> = ({
    games,
    query,
    onQueryChange,
    onSelectGame,
    columnCount = 3,
}) => {
    const isFilled = games.length >= columnCount * 2;
    return (
        <div
            style={
                {
                    '--game-columns': columnCount,
                } as CSSProperties
            }
            className={style()}
        >
            <div className={style('searchbar')}>
                <Icon className={style('search-icon')} name={'search'} />
                <input
                    value={query}
                    onInput={(ev) => onQueryChange((ev.target as HTMLInputElement).value)}
                    className={style('search')}
                />
                {query && (
                    <Icon
                        onClick={() => onQueryChange('')}
                        className={style('clear')}
                        name={'times'}
                    />
                )}
            </div>
            <SliderList
                scrollWidthDivider={4}
                className={style('games', {
                    'row-fill': !isFilled,
                })}
            >
                {games.map((game) => {
                    return (
                        <Thumbnail
                            className={style('game')}
                            key={game.id}
                            slug={game.slug}
                            title={game.name}
                            background={game.thumbnails[0].background || ''}
                            logo={game.thumbnails[0].logo}
                            asset={game.thumbnails[0].asset}
                            variant={game.thumbnails[0].layout?.variant}
                            compact
                            onClick={onSelectGame}
                        />
                    );
                })}
            </SliderList>
        </div>
    );
};
